import TopbarLink from './TopbarLink.vue';

export default TopbarLink;